import template from './sales-by-products.html';
import controller from './sales-by-products.controller';
import './sales-by-products.scss';

let salesByProductsComponent = {
  bindings: {},
  template,
  controller
};

export default salesByProductsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-products/sales-by-products.component.js